import Snackbar from "../../snackbar/Snackbar";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";
import {_transl, t} from "../../../../../store/localization/TranslMessasge";
import {PropertiesTranslationKey} from "../PropertiesTranslationKey";
import DeleteConfirmationDialog from "../../../../../components/dialogs/DeleteConfirmationDialog";

export interface PropertyDeleteApi {
    deleteProperty: (propertyDefinitionId: string) => Promise<void>;
}

export interface PropertyDeleteConfirmationDialogProps {
    open: boolean;
    propertyDefinitionId: string;
    onClose: () => void;
    onDeleted: () => void;
    propertyDeleteApi: PropertyDeleteApi;
}

export default function PropertyDeleteConfirmationDialog(props: Readonly<PropertyDeleteConfirmationDialogProps>) {
    const {open, propertyDefinitionId, propertyDeleteApi, onClose, onDeleted} = props;

    function deleteProperty() {
        propertyDeleteApi.deleteProperty(propertyDefinitionId)
            .then(() => {
                onDeleted();
                onClose();
                Snackbar.success(t(PropertiesTranslationKey.PROPERTY_DELETED_SUCCESSFULLY));
            })
            .catch((error) => Snackbar.error(_transl(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error));
    }

    return (
        <DeleteConfirmationDialog
                open={open}
                title={_transl(PropertiesTranslationKey.DELETE_PROPERTY_PROMPT)}
                message={_transl(PropertiesTranslationKey.PROPERTY_WILL_BE_DELETED)}
                onDelete={deleteProperty}
                onDismiss={onClose} />
    );
}